import { render, staticRenderFns } from "./vsc-checkbox.vue?vue&type=template&id=41ec2b10&"
import script from "./vsc-checkbox.vue?vue&type=script&lang=ts&"
export * from "./vsc-checkbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports